import { ConflictError } from "./conflict-error";

// Thrown by the order guard when a line asks for more of an article than is
// available — the physical balance less what orders still owing a pick have
// reserved. 409, not 400: the payload is well formed, it is the stock that has
// moved out from under it. The per-article detail belongs in the order form,
// which reads `availableQuantity` on every line and can name the article
// before the request is ever sent.
export class InsufficientStockError extends ConflictError {
	constructor() {
		super("stock.insufficient_available_stock");
		this.name = "InsufficientStockError";
	}
}
